import { request, headers, API_BASE_URL } from './apiClient'

export const fetchComparativeConfig = () => request('GET', '/v1/eval/comparative/config')

export const fetchComparativeRuns = () => request('GET', '/v1/eval/comparative/')

export const fetchComparativeRun = (id) => request('GET', `/v1/eval/comparative/${id}/`)

export const saveComparativeRun = (data) => request('POST', '/v1/eval/comparative/', data)

export async function streamComparativeLeg(leg, messages) {
  const response = await fetch(`${API_BASE_URL}/v1/eval/comparative/stream`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ leg, messages }),
  })
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || `HTTP ${response.status}`)
  }
  return response
}
